import React from 'react';
import styled from 'styled-components';
import colors from 'utils/colors';

const ErrorWrapper = props =>
  typeof props.children === 'string' ? (
    <Message color={props.color}>{props.children}</Message>
  ) : null;

const Message = styled.p`
  color: ${props => props.color || colors.darkRed};
  font-size: 1rem;
`;

export default ErrorWrapper;
